export default __webpack_public_path__ + "static/media/DSCN1699.fb42e6bf.JPG";